/* eslint-disable no-console */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';
import withSizes from 'react-sizes';
import SweetAlert from 'sweetalert-react';
import * as GoogleMapApi from '../../../utils/googleApiHelper';
import * as OrdersAction from '../../../actions/ordersActions';
import * as PaymentsActions from '../../../actions/paymentsActions';
import ProductListMobile from '../../../components/cart/ProductListMobile';
import BillDetailsMobile from '../../../components/cart/BillDetailsMobile';
import Loader from '../../../components/commons/loader/loader';
import * as Cart from '../../../utils/cartHelper'
import * as Utils from '../../../utils/utils'
import { fromJS } from 'immutable';
import * as CartActions from '../../../actions/cartActions'
import Rating from 'react-rating';

class OrderDetailsPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      productList: [],
      showAlert: false,
      swalParams: {
        title: ""
      },
      readonly: false,
      textAreaValue: '',
      stars: 0,
      activeButton: true,
      selectedCard: undefined,
      isPaymentInfoEditable: false,
      placeOrderSuccess: false,
      stripe: undefined,
      mode: undefined,
      paymentError: undefined,
      // orderId: ''
    };

    this.loadOrder = this.loadOrder.bind(this);
    this.dispatchCartItems = this.dispatchCartItems.bind(this);
    this.renderContentForDesktop = this.renderContentForDesktop.bind(this)
    this.renderContentForSessionCheckout = this.renderContentForSessionCheckout.bind(this)
    this.renderContentForMobile = this.renderContentForMobile.bind(this)
    this.renderDeliveryDetailsForMobile = this.renderDeliveryDetailsForMobile.bind(this)
    this.submit = this.submit.bind(this);
    this.handleRatingChange = this.handleRatingChange.bind(this);
    this.handleChangeTextArea = this.handleChangeTextArea.bind(this);
    this.handlePaymentCheckoutSessionSubmit = this.handlePaymentCheckoutSessionSubmit.bind(this);
    this.getOrderBillDetails = (order) => {
      return {
        CRV: order.CRV,
        discount: order.discount ? order.discount : {},
        discountByPromoCode: order.discountAmount,
        subTotal: order.subTotal,
        tax: order.tax,
        deliveryFee: order.deliveryFee,
        tip: {percent: order.tipPercentage, amount: order.tip},
        total: order.total
      }
    }
  }

  componentDidMount() {
    const that = this;
    this.loadOrder();
  }

  render() {
    const { showAlert, swalParams } = this.state;
    const {loading} = this.props;
    const {isMobile} = this.props;

    console.log('ORDER_DETAILS_STATE', this.state);
    return (
      <div className={`page order-details-page ${isMobile ? 'mobile' : ''}`}>
        {!isMobile ? this.renderContentForDesktop() : this.renderContentForMobile()}
        <Loader visibility={loading} />
        <SweetAlert
          customClass={"with-close"}
          showCancelButton
          cancelButtonText={"x"}
          onCancel={() => this.setState({ showAlert: false })}
          show={showAlert}
          onConfirm={() => this.setState({ showAlert: false })}
          {...swalParams} />
      </div>
    )
  }

  handlePaymentCheckoutSessionSubmit(fromPending, ev) {
    const that = this;
    const order = this.props.order;
    window.location.replace(order.external_checkout_details.session_url);
  }


  handleRatingChange(value) {
    this.setState({ stars: value});
  }
  submit(order) {
   if(this.state.stars > 0){ 
     this.setState({
      readonly: true,
      activeButton: false,
      showAlert: true,
       swalParams: {
       title: 'Rating Added Sucessfully!',
        type: "success",
        showConfirmButton: false
      }
    });
    this.props.dispatch(OrdersAction.setRating({
      orderId: order._id,
      stars: this.state.stars, 
      review: this.state.textAreaValue,
      driverId: order.driver
      // orderId: order._id,
    })
    );
   } else{
     this.setState({
       // orderId: order._id,
       showAlert: true,
       swalParams: {
         title: 'Please add your star rating.',
         type: "warning",
         showConfirmButton: false
       }
     });
   }
  }

  handleChangeTextArea(event){
    this.setState({ textAreaValue: event.target.value });
  }
  
  renderContentForSessionCheckout() {
    const { order, loading } = this.props;
 return (order.status === "Pending"&&
 !order.transactionID &&
 order.external_checkout_details &&
 order.external_checkout_details.session_id? (
    <div className="row payment-block">
       <div className="col-sm-6">
         <div className="warning">
           YOUR PAYMENT FOR THIS ORDER IS INCOMPLETE. HENCE, THE ORDER IS
           IN PENDING STATE. PLEASE COMPLETE YOUR PAYMENT FROM THE
           OPTIONS BELOW TO COMPLETE THE ORDER. THIS ORDER WILL BE
           CANCELED IN 2 HOURS IF THE PAYMENT IS NOT RECEIVED.
         </div>
         <div className="info-group">
           
           
           <div className="buttons-container">
             <button
               className="button button-blue"
               onClick={() => this.handlePaymentCheckoutSessionSubmit()}
               disabled={loading}
             >
               PAY NOW
             </button>
             
           </div>
         </div>
       </div>
     </div>
 ) : null);
  }
  renderContentForDesktop() {
    const { productList, isPaymentInfoEditable, billDetails} = this.state;
    const { order, loading } = this.props;
    const giftDeliveryDetails = order && order.giftDeliveryDetails ? order.giftDeliveryDetails : undefined;
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-7">
            <h1 className="page-title">Order Details</h1>
          </div>
          <div className="col-md-5">
            <div className="reorder-button-container">
              {order &&
              order.status &&
              order.status.toLowerCase() !== "pending" ? (
                <a
                  href="javascript:void(0)"
                  className="reorder-button"
                  onClick={() => this.reOrder()}
                >
                  REORDER
                </a>
              ) : null}
            </div>
          </div>
        </div>
        <div className="row info-header">
          <div className="col-md-7">
            <div className="address-info">
              {order && order.giftDelivery ? (
                <div className="gift-delivery-details-container">
                  <div className="recipient-details">
                    <div className="title">GIFT DELIVERY Recipient Details</div>
                    {giftDeliveryDetails.recipientName ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.recipientName}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.recipientBusinessName ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.recipientBusinessName}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.recipientAddress ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.recipientAddress.apartment
                            ? `Apartment #: ${giftDeliveryDetails.recipientAddress.apartment}`
                            : ""}{" "}
                          &nbsp;
                          {giftDeliveryDetails.recipientAddress.description}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.recipientEmail ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.recipientEmail}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.recipientPhone ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.recipientPhone}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.giftMessage ? (
                      <div className="info-row">
                        GIFT MESSAGE: &nbsp;
                        <span className="text-italic">
                          {giftDeliveryDetails.giftMessage}
                        </span>
                      </div>
                    ) : null}
                  </div>
                  <div className="sender-details">
                    <div className="title">SENDER DETAILS</div>
                    {giftDeliveryDetails.senderName ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.senderName}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.senderBusinessName ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.senderBusinessName}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.senderAddress ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.senderAddress.apartment
                            ? `Apartment #: ${giftDeliveryDetails.senderAddress.apartment}`
                            : ""}{" "}
                          &nbsp;
                          {giftDeliveryDetails.senderAddress.description}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.senderEmail ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.senderEmail}
                        </span>
                      </div>
                    ) : null}
                    {giftDeliveryDetails.senderPhone ? (
                      <div className="info-row">
                        <span className="text-italic">
                          {giftDeliveryDetails.senderPhone}
                        </span>
                      </div>
                    ) : null}
                    <div className="info-row">
                      SENDER DOB: &nbsp;
                      <span className="text-italic">
                        {giftDeliveryDetails.senderDOB
                          ? Moment(giftDeliveryDetails.senderDOB).format("L")
                          : "Not provided"}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="address-info-container">
                  <div className="title">Address</div>
                  <div className="description">
                    {order && order.address
                      ? order.address.apartment
                        ? `Apartment #:${order.address.apartment}, ${order.address.description}`
                        : order.address.description
                      : ""}
                  </div>
                </div>
              )}
              <div className="title">
                {order && order.deliveryStartTime
                  ? Moment(
                      order.deliveryStartTime === "now"
                        ? order.createdAt
                        : order.deliveryStartTime
                    ).format("ddd DD MMM YYYY")
                  : ""}
              </div>
              <div className="description">
                {order && order.deliveryStartTime === "now"
                  ? `${Moment(order.createdAt).format("hh:mma")} - ${Moment(
                      order.createdAt
                    )
                      .add(60, "minutes")
                      .format("hh:mma")}`
                  : null}
                {order &&
                order.deliveryStartTime != "now" &&
                order.deliveryEndTime
                  ? `${Moment(order.deliveryStartTime).format(
                      "hh:mma"
                    )} - ${Moment(order.deliveryEndTime).format("hh:mma")}`
                  : null}
              </div>
              {order && order.status === "Canceled" && order.refunded ? (
                <div>
                  <div className="title">Refunded On</div>
                  <div className="description refunded-description">
                    {Moment(order.refundedOn).format(
                      "ddd DD MMM YYYY | hh:mma"
                    )}
                  </div>
                  <div className="note">
                    It can take 10+ days for the refund to appear on your
                    statement, if it takes longer please contact Jasons Wine &
                    Spirits for assistance.
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-5 address-map-container">
            <div
              className="address-map"
              ref={elem => (this.mapElement = elem)}
            ></div>
          </div>
        </div>
        <div className="row info-products">
          <div className="col-md-6">
            <div className="info-row">
              <div className="title">Product Details</div>
              {productList ? (
                <div className="row info-product-header">
                  <div className="col-md-6 col-sm-6">Product Name</div>
                  <div className="col-md-3 col-sm-3 text-center">Quantity</div>
                  <div className="col-md-3 col-sm-3">Amount</div>
                </div>
              ) : null}
              {productList &&
                productList.map((product, idx) => {
                  return (
                    <div className="row info-product" key={product._id}>
                      <div className="col-md-6 col-sm-6">
                        {product.Description}
                      </div>
                      <div className="col-md-3 col-sm-3 text-center">
                        {order && order.qty ? order.qty[idx] : ""}
                      </div>
                      <div className="col-md-3 col-sm-3">
                        {order && order.qty
                          ? this.renderProductPrice(product, idx)
                          : ""}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="col-md-6">
            <div className="info-row">
              <div className="content-left">
                <div className="title">Order Status</div>
              </div>
              <div className="content-right">
                <div className="description">{`Status: ${
                  order ? order.status : ""
                }`}</div>
              </div>
            </div>
            <div className="info-row">
              <div className="content-left">
                <div className="title">Order Number</div>
              </div>
              <div className="content-right">
                <div className="description">{`Order#: ${
                  order && order.transactionID
                    ? order.transactionID.substr(-6).toUpperCase()
                    : ""
                }`}</div>
              </div>
            </div>

            <div className="info-row">
              <div className="title">Bill Details</div>
              {order.discount && order.discount.code ? (
                <div className="row info-subrow">
                  <div className="col-md-6 col-sm-6">
                    <div className="label">
                      DISCOUNT
                      {order.discount && order.discount.discountType == 1 ? (
                        <span> - FLAT ${order.discountAmount} OFF</span>
                      ) : (
                        <span> - {order.discount.discount * 100}% OFF</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="value">
                      {order.discountAmount ? `$${order.discountAmount}` : "$0"}
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="row info-subrow">
                <div className="col-md-6 col-sm-6">
                  <div className="label">CRV</div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="value">
                    {order && (order.CRV || order.CRV == 0)
                      ? `$${parseFloat(order.CRV).toFixed(2)}`
                      : "N/A"}
                  </div>
                </div>
              </div>
              <div className="row info-subrow">
                <div className="col-md-6 col-sm-6">
                  <div className="label">SubTotal</div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="value">
                    {order && order.subTotal
                      ? `$${parseFloat(order.subTotal).toFixed(2)}`
                      : ""}
                  </div>
                </div>
              </div>
              <div className="row info-subrow">
                <div className="col-md-6 col-sm-6">
                  <div className="label">
                    Tax
                  </div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="value">
                    {order && order.tax
                      ? `$${parseFloat(order.tax).toFixed(2)}`
                      : ""}
                  </div>
                </div>
              </div>
              <div className="row info-subrow">
                <div className="col-md-6 col-sm-6">
                  <div className="label">Delivery Fee</div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="value">
                    {order && order.deliveryFee
                      ? `$${parseFloat(order.deliveryFee).toFixed(2)}`
                      : "N/A"}
                  </div>
                </div>
              </div>
              <div className="row info-subrow">
                <div className="col-md-6 col-sm-6">
                  <div className="label">Tip</div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="value">
                    {order && (order.tip || order.tip == 0)
                      ? `$${parseFloat(order.tip).toFixed(2)}`
                      : ""}
                  </div>
                </div>
              </div>
              <div className="row info-subrow info-footer">
                <div className="col-md-6 col-sm-6">
                  <div className="label">Total</div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="value">
                    {order && order.total
                      ? `$${parseFloat(order.total).toFixed(2)}`
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.renderContentForSessionCheckout()}
        
        {order.status === "Completed" && (
          <div>
            <div className="review-rating">
              <div className="rating-order">
                <div className="title">Rate Delivery Experience</div>
                <div className="rating-stars">
                  <Rating
                    emptySymbol="fa fa-star-o fa-2x"
                    fullSymbol="fa fa-star fa-2x"
                    onChange={this.handleRatingChange}
                    readonly={
                      this.state.readonly ||
                      (order && order.driverRating && order.driverRating.stars)
                    }
                    initialRating={
                      order && order.driverRating && order.driverRating.stars
                    }
                  />
                </div>
              </div>
            </div>
            <div className="review-order">
              <div>
                <div className="title"> Review this delivery</div>
                <div className="text-area">
                  <textarea
                    rows="5"
                    cols="70"
                    value={
                      order && order.driverRating && order.driverRating.review
                    }
                    onChange={this.handleChangeTextArea}
                    readOnly={
                      this.state.readonly ||
                      (order && order.driverRating && order.driverRating.review)
                    }
                  />
                </div>
              </div>
              {(order && order.driverRating && order.driverRating.stars) ||
              !this.state.activeButton ? null : (
                <div className="review">
                  <button
                    className="submit-review"
                    onClick={() => this.submit(order)}
                  >
                    Submit
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {order.shippoLabelUrl && order.shippoLabelUrl.length > 0 && (
          <div style={{ paddingTop: "40px" }}>
            <div className="title" style={{ paddingBottom: "30px" }}>
              Shipment Details{" "}
            </div>
            <div>
              {order.shippoCancellation ? (
                "The shipment for this order has been canceled"
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "space-between",
                      width: "60%",
                      paddingBottom: "20px",
                      borderBottom: "1px solid #EEE",
                      padding: "15px 0px"
                    }}
                  >
                    <div className="info-row">Tracking URL</div>
                    <div style={{ marginLeft: "60px" }}>
                      {order.shippingCarrier && order.shippingCarrier} -
                      <a
                        href={
                          order.shippoTrackingUrl && order.shippoTrackingUrl
                        }
                        target="_blank"
                      >
                        Tracking Link
                      </a>{" "}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "space-between",
                      width: "60%",
                      paddingBottom: "20px",
                      borderBottom: "1px solid #EEE",
                      padding: "15px 0px"
                    }}
                  >
                    <div className="info-row">Tracking NO</div>
                    <div style={{ marginLeft: "60px" }}>
                      {order.trackingNumber && order.trackingNumber}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderContentForMobile() {
    const { productList, billDetails, isPaymentInfoEditable} = this.state;
    const { order, loading } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 page-title-bar">
            <div className="page-title">Order Details</div>
            {order &&
            order.status &&
            order.status.toLowerCase() !== "pending" ? (
              <a
                href="javascript:void(0)"
                className="reorder-button"
                onClick={() => this.reOrder()}
              >
                REORDER
              </a>
            ) : null}
            <div
              className="address-map"
              ref={elem => (this.mapElement = elem)}
            ></div>
          </div>
        </div>

        {this.renderDeliveryDetailsForMobile()}

        <div className="section-header">
          ORDER STATUS: &nbsp;&nbsp;<i>{order && order.status}</i>
        </div>

        <div className="section-header">
          ORDER NUMBER: &nbsp;&nbsp;
          <i>
            {order && order.transactionID
              ? order.transactionID.substr(-6).toUpperCase()
              : ""}
          </i>
        </div>

        {productList ? (
          <ProductListMobile products={productList} order={order} />
        ) : null}

        {billDetails ? <BillDetailsMobile billDetails={billDetails} /> : null}
        {this.renderContentForSessionCheckout()}
        {order.status === "Completed" && (
          <div>
            <div className="review-rating">
              <div className="rating-order">
                <div className="title">Rate Delivery Experience</div>
                <div className="rating-stars">
                  <Rating
                    emptySymbol="fa fa-star-o fa-2x"
                    fullSymbol="fa fa-star fa-2x"
                    onChange={this.handleRatingChange}
                    readonly={
                      this.state.readonly ||
                      (order && order.driverRating && order.driverRating.stars)
                    }
                    initialRating={
                      order && order.driverRating && order.driverRating.stars
                    }
                  />
                </div>
              </div>
            </div>
            <div className="review-order">
              <div>
                <div className="title"> Review this delivery</div>
                <div className="text-area">
                  <textarea
                    rows="5"
                    cols="45"
                    value={
                      order && order.driverRating && order.driverRating.review
                    }
                    onChange={this.handleChangeTextArea}
                  />
                </div>
              </div>
              {order &&
              order.driverRating &&
              order.driverRating.stars ? null : (
                <div className="review">
                  <button
                    className="submit-review"
                    onClick={() => this.submit(order)}
                  >
                    Submit
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {order.shippoLabelUrl && order.shippoLabelUrl.length > 0 && (
          <div style={{ paddingTop: "40px" }}>
            <div className="title" style={{ paddingBottom: "30px" }}>
              Shipment Details{" "}
            </div>
            <div>
              {order.shippoCancellation ? (
                "The shipment for this order has been canceled"
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "space-between",
                      width: "60%",
                      paddingBottom: "20px",
                      borderBottom: "1px solid #EEE",
                      padding: "15px 0px"
                    }}
                  >
                    <div className="info-row">Tracking URL</div>
                    <div style={{ marginLeft: "60px" }}>
                      {order.shippingCarrier && order.shippingCarrier} -
                      <a
                        href={
                          order.shippoTrackingUrl && order.shippoTrackingUrl
                        }
                        target="_blank"
                      >
                        Tracking Link
                      </a>{" "}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "space-between",
                      width: "60%",
                      paddingBottom: "20px",
                      borderBottom: "1px solid #EEE",
                      padding: "15px 0px"
                    }}
                  >
                    <div className="info-row">Tracking NO</div>
                    <div style={{ marginLeft: "60px" }}>
                      {order.trackingNumber && order.trackingNumber}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderDeliveryDetailsForMobile() {
    const { order } = this.props;
    const giftDeliveryDetails = order && order.giftDeliveryDetails ? order.giftDeliveryDetails : undefined;
    return (
      <div className="row delivery-details-container">
        <div className="delivery-details-content">
          {order && order.giftDelivery ? (
            <div className="gift-delivery-details-container">
              <div className="recipient-details">
                <div className="title">GIFT DELIVERY RECIPIENT DETAILS</div>
                {giftDeliveryDetails.recipientName ?
                  <div className="info-row">
                    <span className="description">{giftDeliveryDetails.recipientName}</span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.recipientBusinessName ?
                  <div className="info-row">
                    <span className="description">{giftDeliveryDetails.recipientBusinessName}</span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.recipientAddress ?
                  <div className="info-row">
                    <span className="description">
                      {giftDeliveryDetails.recipientAddress.apartment ? `Apartment #: ${giftDeliveryDetails.recipientAddress.apartment} ` : ''}
                      {giftDeliveryDetails.recipientAddress.description}
                    </span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.recipientEmail ?
                  <div className="info-row">
                    <span className="description">{giftDeliveryDetails.recipientEmail}</span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.recipientPhone ?
                  <div className="info-row">
                    <span className="description">{giftDeliveryDetails.recipientPhone}</span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.giftMessage ?
                  <div className="info-row">GIFT MESSAGE: &nbsp;
                    <span className="description">{giftDeliveryDetails.giftMessage}</span>
                  </div>
                  : null
                }
              </div>
              <div className="sender-details">
                <div className="title">SENDER DETAILS</div>
                {giftDeliveryDetails.senderName ?
                  <div className="info-row">
                    <span className="description">{giftDeliveryDetails.senderName}</span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.senderBusinessName ?
                  <div className="info-row">
                    <span className="description">{giftDeliveryDetails.senderBusinessName}</span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.senderAddress ?
                  <div className="info-row">
                    <span className="description">
                      {giftDeliveryDetails.senderAddress.apartment ? `Apartment #: ${giftDeliveryDetails.senderAddress.apartment} ` : ''}
                      {giftDeliveryDetails.senderAddress.description}
                    </span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.senderEmail ?
                  <div className="info-row">
                    <span className="description">{giftDeliveryDetails.senderEmail}</span>
                  </div>
                  : null
                }
                {giftDeliveryDetails.senderPhone ?
                  <div className="info-row">
                    <span className="description">{giftDeliveryDetails.senderPhone}</span>
                  </div>
                  : null
                }
                <div className="info-row">SENDER DOB: &nbsp;
                  <span className="description">
                    {giftDeliveryDetails.senderDOB ? Moment(giftDeliveryDetails.senderDOB).format('L') : 'Not provided'}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="title">Delivery To</div>
              <div className="description">{order && order.address
                ? order.address.apartment ? `Apartment #:${order.address.apartment}, ${order.address.description}` : order.address.description
                : ''}
              </div>
            </div>
          )}

          <div className="title">Delivery Time</div>
          <div className="description">
            {order && order.deliveryStartTime
              ? Moment(order.deliveryStartTime === 'now'
              ? order.createdAt
              : order.deliveryStartTime).format('ddd, DD MMM YYYY')
              : ''}, &nbsp;
            {order && order.deliveryStartTime === 'now'
                ? `${Moment(order.createdAt).format('hh:mma')} - ${Moment(order.createdAt).add(60, 'minutes').format('hh:mma')}`
                : null
            }
            {order && order.deliveryStartTime != 'now' && order.deliveryEndTime
              ? `${Moment(order.deliveryStartTime).format('hh:mma')} - ${Moment(order.deliveryEndTime).format('hh:mma')}`
              : null
            }
          </div>
          {order && order.status === 'Canceled' && order.refunded ?(
            <div>
              <div className="title">Refunded On</div>
              <div className="description refunded-description">{Moment(order.refundedOn).format('ddd DD MMM YYYY | hh:mma')}</div>
              <div className="note">It can take 10+ days for the refund to appear on your statement, if it takes longer please contact Jasons Wine & Spirits for assistance.</div>
            </div>
            ) : null
          }
        </div>
        <div className="address-map" ref={(elem) => this.mapElement = elem}></div>
      </div>
    )
  }

  renderProductPrice(product, idx) {
    const { order } = this.props;
    if (order.productsPriceHistory && order.productsPriceHistory.length) {
      const priceHistory = order.productsPriceHistory.find((p) => {
        return p._id == product._id;
      });
      return (
        (priceHistory['OnSale'] || priceHistory['bundle']) ?
          <span>
            <s>{`$${(parseFloat(priceHistory['PriceB'] * order.qty[idx])).toFixed(2)}`}</s>
            {` $${(parseFloat(priceHistory['SalePrice'] * order.qty[idx])).toFixed(2)}`}
          </span>
          :
          <span>
            {`$${(parseFloat(priceHistory['PriceB'] * order.qty[idx])).toFixed(2)}`}
          </span>
      );
    } else {
      return (
        <span>
          {`$${(parseFloat(product['PriceB'] * order.qty[idx])).toFixed(2)}`}
        </span>
      )
    }
  }

  loadOrder() {

    const { match } = this.props;
    let orderId = match.params && match.params.orderId
      ? match.params.orderId
      : null;
    if (!orderId) {
      console.error("Order id is required");
      return;
    }

    this.props.dispatch(OrdersAction.getOrderDetails(orderId, response => {

      console.log('ORDER_GET_RESPONSE', response);

      if (response.status) {
        if (response.data.address) {
          this.map = GoogleMapApi.initMap(this.mapElement);
          this.marker = GoogleMapApi.addMarker(this.map, {
            lat: response.data.address.loc[1],
            lng: response.data.address.loc[0]
          });
        }
        this.setState({
          productList: response.data.products,
          billDetails: this.getOrderBillDetails(response.data),
        })
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: "Failed to load order details, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }));
  }

  reOrder() {
    Cart.clearCart();
    let cartItems = {};
    const productList = this.state.productList;
    const order = this.props.order;
    let outOfStockProducts = []
    productList.map((product, index) => {
      let copyOfProduct = fromJS(product).toJS()
      let isRecommendedProduct = Utils.isRecommendedProduct(product)
      if (isRecommendedProduct) {
        copyOfProduct['quantity'] = order['qty'][index]
        cartItems[product._id] = copyOfProduct
      }
      else if (parseInt(product['Qty']) >= order['qty'][index]) {
        copyOfProduct['quantity'] = order['qty'][index]
        cartItems[product._id] = copyOfProduct
      }
      else {
        outOfStockProducts.push(product)
        if (parseInt(product['Qty']) > 0) {
          copyOfProduct['quantity'] = parseInt(product['Qty'])
          cartItems[product._id] = copyOfProduct
        }
      }
    })
    if (outOfStockProducts.length && Object.keys(cartItems).length) {
      this.setState({
        showAlert: true,
        swalParams: {
          title: "Some of the products were out if stock. So, we will add as many items in stock for those products.",
          type: "info",
          showConfirmButton: true,
          onConfirm: () => {
            this.setState({ showAlert: false })
            this.dispatchCartItems(cartItems);
          }
        }
      })
    }
    else if (Object.keys(cartItems).length) {
      this.dispatchCartItems(cartItems)
    }
    else {
      this.setState({
        showAlert: true,
        swalParams: {
          title: "None of the products in this order were in stock. Please try reordering again later.",
          type: "info",
          showConfirmButton: true
        }
      })
    }
  }

  dispatchCartItems(cartItems) {
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_CART_ITEMS, {
      items: cartItems
    }));
    this.props.history.push('/cart');
  }

}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    order: state.getIn(['orders', 'recentOrder']),
    loading: (state.getIn(['payments', 'loading']) || state.getIn(['orders', 'loading'])),
  };
})(OrderDetailsPage))



// WEBPACK FOOTER //
// ./src/containers/settings/orders/OrderDetailsPage.js